import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setReceiverPhoneNumber } from './receiverSlice';

import Input from '../../components/BaseInput';
import PropTypes from 'prop-types';

export default function PhoneNumberInput(props) {
  const { onEnter } = props;

  const { phoneNumber: phoneNumberFromState } = useSelector((state) => state.receiver);
  const dispatch = useDispatch();

  const [phoneNumber, setPhoneNumber] = useState(phoneNumberFromState);

  useEffect(() => {
    const search = window.location.search;
    if (search) {
      const searchIsValid = search.includes('phoneNumber=');
      if (searchIsValid) {
        const phoneNumberItemFromSearch = search.split('phoneNumber=')[1];

        if (phoneNumberItemFromSearch) {
          const phoneNumberFromSearch = decodeURIComponent(phoneNumberItemFromSearch.split('&')[0]);
          if (phoneNumberFromSearch) {
            dispatch(setReceiverPhoneNumber(phoneNumberFromSearch));
            setPhoneNumber(phoneNumberFromSearch);
          }
        }
      }
    }
  }, [dispatch]);

  useEffect(() => {
    setPhoneNumber(phoneNumberFromState);
  }, [phoneNumberFromState]);

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
    handleSavePhoneNumber(event.target.value);
  };

  const handleSavePhoneNumber = (phoneNumber) => {
    let number = phoneNumber;
    if (number.startsWith('0')) {
      number = number.substring(1);
    }

    dispatch(setReceiverPhoneNumber(number));
  };

  const handleKeyPress = ({ key }) => {
    if (key === 'Enter') {
      handleSavePhoneNumber(phoneNumber);
      onEnter({ phoneNumber });
    }
  };

  const handleBlur = ({ target }) => {
    if (target.value !== phoneNumberFromState) {
      handleSavePhoneNumber(target.value);
    }
  };

  return (
    <div className="form-group phone-number">
      <Input
        type="number"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        placeholder="Enter number"
        pattern={'(^[0-9]{1,12}$)'}
        title="Phone number should contain just numbers (max 12 digits)"
        onKeyPress={handleKeyPress}
        onBlur={handleBlur}
      />
    </div>
  );
}

PhoneNumberInput.propTypes = {
  onEnter: PropTypes.func,
};

PhoneNumberInput.defaultProps = {
  onEnter: () => {
    console.log('missing logic');
  },
};
